import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Headaches.module.css';
import { DBCheckBox } from '_components';


class PatientCareCenterNoteSubjectiveHeadaches extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteSection id='sub_headaches' name='Headaches' level={1}>
                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBHEADUNILAT' className={styles.col2} label='Unilateral' />
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBHEADSTAB' className={styles.col3} label='Stabbing' />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBHEADBILAT' className={styles.col2} label='Bilateral' />
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBHEADAURA' className={styles.col3} label='Aura' />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBHEADPULSE' className={styles.col2} label='Pulsating' />
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBHEADPHOTO' className={styles.col3} label='Photophobia' />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBHEADTHROB' className={styles.col2} label='Throbbing' />
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBHEADPHONO' className={styles.col3} label='Phonophobia' />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBHEADSHARP' className={styles.col2} label='Sharp' />
                </div>
            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);

    return {
        noteId: noteId,
        evno: evno,
    };
}

const connectedPatientCareCenterNoteSubjectiveHeadaches = connect(mapStateToProps)(PatientCareCenterNoteSubjectiveHeadaches);
export { connectedPatientCareCenterNoteSubjectiveHeadaches as PatientCareCenterNoteSubjectiveHeadaches };

